import { Injectable } from '@angular/core';
import { AuthService, LanguageService } from '@spartacus/core';
import { StorageService } from './storage.service';
import { GlobalTrackingService } from './global-tracking.service';
import { ActionType, Country, LoginStatus, pageData, PageReadyData, userData } from '../models/global-tracking.model';
import { DATA } from '../models/faq-tracking.model';
import { of, switchMap, take } from 'rxjs';
import { AppConstants, pageIds } from '../constants/app-constant';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class FaqTrackingService {

  constructor(
    private globalTrackingService: GlobalTrackingService,
    private storageService: StorageService,
    private globalTracking: GlobalTrackingService,
    private authService: AuthService,
    private languageService: LanguageService,
    private router: Router
  ) { }

  pageLoadTrackingData(): void {
    let language: string
    this.languageService.getActive().subscribe((lang) => {
      language = lang;
    });
    this.authService.isUserLoggedIn()
      .pipe(
        switchMap(data => {
          const page: pageData = {
            path: this.router.url,
            title: AppConstants.breadcrumbUrls[AppConstants.routeUrls.faq.substring(1)] || '',
            country: Country.COUNTRY,
            language: language || '',
            template: pageIds.PID_23,
          };

          const user: userData = {
            loginStatus: data ? LoginStatus.LOGGED_IN : LoginStatus.LOGGED_OUT,
            role: this.storageService?.userRoles || '',
            company: this.storageService?.defaultLegalEntity?.name || '',
            companyId: '',
          };

          const pageLoadData: PageReadyData = {
            page: page,
            user: user,
          };
          this.globalTrackingService.sendPageReadyData(ActionType.PAGE_READY, pageLoadData)
          return of(null);
        }),
        take(1),
      )
      .subscribe();
  }

  trackVideoLayerOpen(action: ActionType, clickTarget: HTMLElement): void {
    let faqVal: DATA = {
      layer: {
        name: 'video'
      }
    }
    this.globalTracking.sendTrackingEvent(action, faqVal, clickTarget)
  }
}